import fetchClient from '../components/common/FetchClient';

const requestType = 'REQUEST_SUBMIT_CHECK_IN';
const receiveType = 'RECEIVE_SUBMIT_CHECK_IN';

const initialState = {
    isLoading: false
};

export const actionCreators = {

    getCheckInHistory: data => async (dispatch, getState) => {
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestType) {

        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveType) {

        return {
            ...state,
            isLoading: false
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/CheckIn.js